import { useMemo } from 'react';
import PropTypes from 'prop-types';

import CssBaseline from '@mui/material/CssBaseline';
import {
    createTheme,
    ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles';

import { palette } from './palette';
import { shadows } from './shadows';
import { overrides } from './overrides';
import { typography } from './typography';
import { customShadows } from './custom-shadows';
import { useRecoilState } from 'recoil';
import { settingState } from '../recoil/settingState';

// ----------------------------------------------------------------------

export default function ThemeProvider({ children }) {
    const memoizedValue = useMemo(
        () => ({
            palette: palette(),
            typography,
            shadows: shadows(),
            customShadows: customShadows(),
            shape: { borderRadius: 8 },
        }),
        []
    );

    const theme = createTheme(memoizedValue);

    const [setting] = useRecoilState(settingState);

    theme.components = overrides(theme, { setting });

    return (
        <MUIThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </MUIThemeProvider>
    );
}

ThemeProvider.propTypes = {
    children: PropTypes.node,
};
